module.exports = __webpack_public_path__ + "static/media/send-2.c48d6a25.svg";